import { useEffect, useState } from 'react';
import EventOverview from '../../organisms/EventOverview';
import mapEventProps from '~/helpers/renderer/mapping/mapEventProps';
import mapSelectBoxOptions from '~/helpers/renderer/mapping/mapSelectBoxOptions';
import fetchEvents from '~/api/helpers/fetchEvents';
import { useIntl } from 'react-intl';

/**
 * @param {EventOverviewSearchProps} props
 * @returns {React.ReactElement} The rendered component
 */
function EventOverviewSearch({
  searchId,
  targetGroupId,
  locationId,
  language,

  initialResult = {
    items: [],
  },

  queryBuilder,
}) {
  const [result, setResult] = useState(initialResult);
  const [location, setLocation] = useState(undefined);
  const [targetGroup, setTargetGroup] = useState(undefined);
  const [targetGroupOptions, setTargetGroupOptions] = useState();
  const [locationGroupOptions, setLocationGroupOptions] = useState();
  const intl = useIntl();

  /**
   * @param {QueryParam<DataQuery>} query
   * @returns {EventDataFetcher}
   */
  const fetchData = async (query) => {
    const groups = [];
    if (targetGroupId) {
      groups.push({
        categoryIds: [targetGroupId],
        withItems: false,
        withCounts: false,
      });
    }
    if (locationId) {
      groups.push({
        categoryIds: [locationId],
        withItems: false,
        withCounts: false,
      });
    }

    return fetchEvents(searchId, {
      language,
      query,
      groups,
    });
  };

  // Initial fetch
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    fetchData().then((val) => {
      setResult(val);
    });
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!targetGroupOptions) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setTargetGroupOptions(
        result.groups?.find((group) => group.id === targetGroupId)?.terms,
      );
    }
    if (!locationGroupOptions) {
      setLocationGroupOptions(
        result.groups?.find((group) => group.id === locationId)?.terms,
      );
    }
  });
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <EventOverview
      targetGroupSelector={
        targetGroupId
          ? {
              placeholder: intl.formatMessage({
                id: 'eventOverview.targetGroupPlaceholder',
              }),
              options: mapSelectBoxOptions(targetGroupOptions),
              handleSelect: async (obj) => {
                const { value } = obj;
                const newResult = await fetchData(
                  location ? queryBuilder.and(location, value) : value,
                );
                // TODO: check if still is mount
                setTargetGroup(value);
                setResult(newResult);
              },
              deselectOption: {
                description: intl.formatMessage({
                  id: 'eventOverview.targetGroupDeselectDescription',
                }),
                handleSelect: async () => {
                  const newResult = await fetchData(location);
                  // TODO: check if still is mount
                  setTargetGroup(undefined);
                  setResult(newResult);
                },
              },
            }
          : undefined
      }
      locationSelector={
        locationId
          ? {
              placeholder: intl.formatMessage({
                id: 'eventOverview.locationPlaceholder',
              }),
              options: mapSelectBoxOptions(locationGroupOptions),
              handleSelect: async (obj) => {
                const { value } = obj;
                const newResult = await fetchData(
                  targetGroup ? queryBuilder.and(targetGroup, value) : value,
                );
                // TODO: check if still is mount
                setLocation(value);
                setResult(newResult);
              },
              deselectOption: {
                description: intl.formatMessage({
                  id: 'eventOverview.locationDeselectDescription',
                }),
                handleSelect: async () => {
                  const newResult = await fetchData(targetGroup);
                  // TODO: check if still is mount
                  setLocation(undefined);
                  setResult(newResult);
                },
              },
            }
          : undefined
      }
      events={result.items.map(mapEventProps)}
    />
  );
}

export default EventOverviewSearch;
